import { render, staticRenderFns } from "./DialogEditCriteria.vue?vue&type=template&id=6a26d533"
import script from "./DialogEditCriteria.vue?vue&type=script&lang=js"
export * from "./DialogEditCriteria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports